import { ErrorBoundary, ThemeProvider, ToastProvider, TooltipProvider } from '@prismeet/react'
import type { ReactNode } from 'react'

import { QueryProvider } from './QueryProvider'
import { SessionProvider } from './SessionProvider'
import { SocketProvider } from './SocketProvider'

/**
 * Стек провайдеров хоста.
 *
 * Порядок вложенности читается сверху вниз как зависимости:
 *
 *   ErrorBoundary   — снаружи всех, иначе падение провайдера некому поймать
 *   ThemeProvider   — тему должен видеть даже экран ошибки
 *   QueryProvider   — сессия подтверждается запросом
 *   SessionProvider — сокету нужен токен
 *   SocketProvider  — всё остальное приложение
 *
 * ToastProvider и TooltipProvider стоят соседями, а не обёртками: они
 * рендерят портал в document.body и ничего не оборачивают. Дерево от этого
 * не углубляется, а порядок монтирования всё равно соблюдён — оба внутри
 * темы, из которой берут цвета.
 *
 * Роутер монтируется внутри стека, а не снаружи: страницы и гварды читают
 * сессию из контекста, и провайдер обязан быть над ними.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary showDetails={import.meta.env.DEV}>
      <ThemeProvider defaultTheme="system">
        <QueryProvider>
          <SessionProvider>
            <SocketProvider>{children}</SocketProvider>
          </SessionProvider>

          <ToastProvider position="bottom-right" />
          <TooltipProvider />
        </QueryProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
